import React from 'react'
import EyebrowHeader from './eyebrowHeader'

const ContentBlock = props => {
    const { title, subTitle, eyeBrow, blackBG, body, image } = props
  return (
    <section 
        className={'min-h-72 lg:min-h-[600px] flex flex-col justify-center items-center gap-4 md:text-center px-4 md:px-20 py-16 ' + (blackBG? " bg-black text-white" : " ")}
    >
        <EyebrowHeader left text={eyeBrow}/>
        <h2 className="font-playFair text-3xl md:text-5xl 2xl:text-6xl">{title}</h2>
        <p className=' text-sm md:text-base'>{subTitle}</p>
        <p className='text-sm md:text-base'>{body}</p>
        <img src={image} className="w-full md:w-2/3" alt="" />
    </section>
  )
}

export default ContentBlock